module.exports = __webpack_public_path__ + "img/5.f7b32626.jpg";